/* eslint-disable ember/no-classic-components */
import Component from "@ember/component";
import { concat } from "@ember/helper";
import { compare } from "@ember/utils";
import { tagName } from "@ember-decorators/component";
import routeAction from "discourse/helpers/route-action";
import { getTopicFooterButtons } from "discourse/lib/register-topic-footer-button";
import DButton from "discourse/ui-kit/d-button";
import dConcatClass from "discourse/ui-kit/helpers/d-concat-class";

@tagName("")
export default class AnonymousTopicFooterButtons extends Component {
  get allButtons() {
    return getTopicFooterButtons(this);
  }

  get buttons() {
    return (
      this.allButtons
        .filter((button) => button.anonymousOnly === true)
        .sort((a, b) => compare(a?.priority, b?.priority))
        // Reversing the array is necessary because when priorities are not set,
        // we want to show the most recently added item first
        .reverse()
    );
  }

  <template>
    <div role="region" id="topic-footer-buttons" ...attributes>
      <div class="topic-footer-main-buttons">
        {{#each this.buttons key="id" as |button|}}
          <DButton
            @action={{button.action}}
            @icon={{button.icon}}
            @translatedLabel={{button.label}}
            @translatedTitle={{button.title}}
            @translatedAriaLabel={{button.ariaLabel}}
            @disabled={{button.disabled}}
            id={{concat "topic-footer-button-" button.id}}
            class={{dConcatClass
              "btn-default"
              "topic-footer-button"
              button.classNames
            }}
          />
        {{/each}}
        <DButton
          @icon="reply"
          @action={{routeAction "showLogin"}}
          @label="topic.reply.title"
          class="btn-primary"
        />
      </div>
    </div>
  </template>
}
